module.exports = __webpack_public_path__ + "img/011.ade0498b.jpeg";